import { Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../services/auth';
import { StorageService } from '../../services/storage';
import { MenuService } from '../../services/menu';

@Component({
  selector: 'app-forbidden',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './forbidden.html',
  styleUrls: ['./forbidden.css'],
})
export class Forbidden {
  private router = inject(Router);
  private auth = inject(AuthService);
  private storage = inject(StorageService);
  private menu = inject(MenuService);

  loading = signal(false);

  /** '/dashboard' is the role dispatcher — lands admins/partners on their own home. */
  goHome() {
    this.router.navigate(['/dashboard']);
  }

  logout() {
    this.loading.set(true);
    this.auth.logout().subscribe({
      next: () => this.finish(),
      error: () => this.finish(),
    });
  }

  private finish() {
    this.storage.clearAll();
    this.menu.reset();
    this.router.navigate(['/login']);
  }
}
